'use client'

// CartStoreHydrator — triggers the Zustand cart store's post-mount rehydration
// (Overmind retirement, Bucket C). The cart store is created with
// `skipHydration: true` so the store holds an EMPTY cart during SSR and the first
// client render (cache-safety #188 + no #418/#423 hydration mismatch). This tiny
// island — mounted ONCE in the server SiteChrome shell, so it runs on every page —
// calls `useCartStore.persist.rehydrate()` in a mount effect to read the visitor's
// saved cart from localStorage after the first render commits.
//
// It renders nothing. Kept separate from the cart panel so the rehydrate trigger
// does not depend on the panel's mount timing.
import { useEffect } from 'react'
import { useCartStore } from '../store/cartStore'

export default function CartStoreHydrator() {
  useEffect(() => {
    // rehydrate() is idempotent; guard anyway so a remount does not re-read.
    if (!useCartStore.getState()._hasHydrated) {
      useCartStore.persist.rehydrate()
    }
  }, [])
  return null
}
